import { render, staticRenderFns } from "./editLanguage.vue?vue&type=template&id=0ff139dd&scoped=true&"
import script from "./editLanguage.vue?vue&type=script&lang=js&"
export * from "./editLanguage.vue?vue&type=script&lang=js&"
import style0 from "./editLanguage.vue?vue&type=style&index=0&id=0ff139dd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff139dd",
  null
  
)

export default component.exports